module.exports = __webpack_public_path__ + "img/emoji_46.d2b28309.png";